import {Component, Input} from "@angular/core";
import {Http, RequestOptions} from "@angular/http";
import {environment} from "../environments/environment";

@Component({
  selector: "html-object",
  templateUrl: "./html-object.component.html",
})
export class HtmlObjectComponent {
  private _id: string;
  html: string = "";

  constructor(private http: Http) {}

  load() {
    this.http.post(
      `${environment.httpBase}/objects/${this._id}`,
      {},
      new RequestOptions({withCredentials: true}),
    )
      .toPromise()
      .then(
        (result) => {
          this.html = result.text();
        },
        (error) => {
          this.html = "";
          console.error(error);
        },
      );
  }

  @Input("objectId")
  set id(id: string) {
    this._id = id;
    this.load();
  }

  get id(): string {
    return this._id;
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/html-object.component.ts